"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function ProductsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="animate-pulse">
            <div className="aspect-square bg-muted border border-border p-2 rounded-md"></div>
            <div className="h-6 bg-muted mt-4 w-1/2 mx-auto rounded-md"></div>
          </div>)}
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
      {posts.map((post, i) => {
      let imgProps: React.ImgHTMLAttributes<HTMLImageElement> & {
        "data-wvc-srcset"?: string;
        "data-wvc-sizes"?: string;
      } = {
        src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placeholder_structural.png",
        "data-wvc-srcset": "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placeholder_structural.png-wvc-srcset",
        "data-wvc-sizes": "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placeholder_structural.png-wvc-sizes"
      };
      if (post.customFields?.imagen) {
        imgProps = {
          src: post.customFields.imagen,
          "data-wvc-srcset": "",
          "data-wvc-sizes": ""
        };
      } else if (post.featuredImage) {
        imgProps = {
          src: post.featuredImage
        };
      }
      return <div key={post.id} data-index={i}>
            <Link to={post.link || "#"} className="group block">
              <div className="border border-border p-2 bg-background transition-shadow hover:shadow-sm rounded-md">
                <div className="aspect-square overflow-hidden bg-muted/10 rounded-sm">
                  <img {...imgProps} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
                </div>
              </div>
              <h3 className="text-center mt-4 text-xl font-medium text-foreground group-hover:text-primary transition-colors font-default">
                {post.title}
              </h3>
            </Link>
          </div>;
    })}
    </div>;
}
export default function StructuralProductsGrid() {
  const wp_query_params = {
    post_type: "subproducto",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="structural-products-grid" className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <p className="text-muted-foreground text-base md:text-lg mb-8 max-w-4xl font-sans">
          componentes en su mayoría son columnas y vigas de acero, estos elementos nos ayudan para soportar el suelo, techo y las paredes de un edificio. Los perfiles se nombran en forma abreviada usando su altura o peralte y su peso por unidad de longitud.
        </p>
        
        <PostsProvider wp_query={{
        post_type: "subproducto",
        per_page: 3
      }}>
          <ProductsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}